// extracted by mini-css-extract-plugin
module.exports = {"popupText":"popupText--7QQIL","entityKey":"entityKey--S0mlb","popupCapture":"popupCapture--enJLY","popupTitle":"popupTitle--NfZog","popupTextWrap":"popupTextWrap--QAdrX"};